import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=adc25464&scoped=true&"
import script from "./IncidentList.vue?vue&type=script&lang=ts&"
export * from "./IncidentList.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentList.vue?vue&type=style&index=0&id=adc25464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc25464",
  null
  
)

export default component.exports